import { render } from "./all-blog.vue?vue&type=template&id=49bd4390"
import script from "./all-blog.vue?vue&type=script&lang=js"
export * from "./all-blog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__